(() => {
  if (window.__nooklumeDiscountTiersBound) return;
  window.__nooklumeDiscountTiersBound = true;

  const timers = new WeakMap();
  const enhance = (scope) => {
    if (scope.matches && scope.matches('[data-nl-discount-tiers]')) {
      scope.classList.add('is-enhanced');
    }
    scope.querySelectorAll?.('[data-nl-discount-tiers]').forEach((root) => {
      root.classList.add('is-enhanced');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  } else {
    enhance(document);
  }
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));

  const fallbackCopy = (value) => {
    const field = document.createElement('textarea');
    field.value = value;
    field.readOnly = true;
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    let copied = false;
    try {
      copied = document.execCommand('copy');
    } finally {
      field.remove();
    }
    return copied;
  };

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;

    const toggle = event.target.closest('[data-nl-discount-toggle]');
    if (toggle) {
      const root = toggle.closest('[data-nl-discount-tiers]');
      if (!root) return;
      const open = root.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Hide other discounts' : 'Show more discounts');
      return;
    }

    const button = event.target.closest('[data-nl-discount-copy]');
    if (!button) return;
    const root = button.closest('[data-nl-discount-tiers]');
    const code = button.getAttribute('data-nl-discount-copy');
    if (!root || !code) return;

    let copied = false;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
        copied = true;
      }
    } catch (_) {
      copied = false;
    }
    if (!copied) {
      try {
        copied = fallbackCopy(code);
      } catch (_) {
        copied = false;
      }
    }

    const status = root.querySelector('[data-nl-discount-status]');
    if (copied) {
      button.textContent = '✓';
      button.classList.add('is-copied');
      button.setAttribute('aria-label', 'Copied discount code ' + code);
      if (status) status.textContent = code + ' copied';
    } else {
      const codeText = button.closest('.nooklume-discount-tiers__row')?.querySelector('code');
      if (codeText && window.getSelection && document.createRange) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(codeText);
        selection.removeAllRanges();
        selection.addRange(range);
      }
      button.textContent = 'Select code';
      button.classList.remove('is-copied');
      button.setAttribute('aria-label', 'Select discount code ' + code);
      if (status) status.textContent = 'Clipboard unavailable. Select the code and copy it manually.';
    }
    clearTimeout(timers.get(button));
    timers.set(button, setTimeout(() => {
      button.textContent = 'Copy';
      button.classList.remove('is-copied');
      button.setAttribute('aria-label', 'Copy discount code ' + code);
    }, 2200));
  });
})();
